(function () {
    'use strict';
    var controllerId = 'monitora';
    angular.module('app').controller(controllerId, ['$rootScope', "bootstrap.dialog", '$scope', '$uibModal', '$uibModalInstance', 'datacontext', 'sectionMenu', "common", "item", "allievi", "$translate", "$interval", monitora]);

    function monitora($rootScope, bDialog, $scope, $uibModal, $uibModalInstance, datacontext, sectionMenu, common, item, allievi, $translate, $interval) {
        $scope.item = item;
        $scope.allievi = allievi;
        $scope.rigeneraCodiceDisabled = false;
        $scope.disattivaDisabled = false;
        $scope.completaDisabled = false;
        $scope.rigeneraCodice = rigeneraCodice;
        $scope.unlockModal = unlockModal;
        $scope.disable = disattiva;
        $scope.disattivaSessione = false;
        $scope.complete = completa;
        $scope.timerStart = timerStart;
        $scope.monitorThread = undefined;
        $scope.timerThread = undefined;
        $scope.time = 0;
        getRecord();       
        
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
            monitorStop();
            timerStop();
        };

        function getRecord() {
            return datacontext.session_get(item.Id).then(function (data) {
                if (data == null)
                    return;

                if (data.performed == true)
                    //$location.path('/sessionHistoryDetail').search('SessionId', data.Id);

                $scope.item = data;
                if (data.enabled && data.expires) {
                    datacontext.session_getSecondsRemaining(data.Id).then(function (seconds) {
                        if (seconds != null)
                            $scope.time = seconds > 0 ? seconds : 0;
                        else
                            $scope.time = 0;

                        //Inizio timer					
                        $scope.timerThread = $interval(timerStart, 1000);
                        return $scope.item = data;
                    });
                }

                //Inizio monitoraggio
                monitorStart();
                $scope.monitorThread = $interval(monitorStart, 2000);
                return $scope.item = data;
            });
        }

        function rigeneraCodice() {
            $scope.rigeneraCodiceDisabled = true;

            datacontext.session_createCode($scope.item.Id).then(function (data) {
                if (data == null) {
                    $scope.rigeneraCodiceDisabled = false;
                    return;
                }

                $scope.item = data;

                $scope.rigeneraCodiceDisabled = false;
            });
        }

        function unlockModal(student) {
            if (student.locked == true) {
                var title = $translate.instant('SbloccoStudente');
                var msg = $translate.instant('SbloccaStudente') + ": " + student.studente + "?";
                bDialog.confirmationDialog(title, msg).then(function () {
                    if (student.locked == true) {
                        $rootScope.unlock = true;

                        $rootScope.studentToUnlockId = student.Id;
                        $rootScope.studentToUnlock = student.studente;
                        unlock();
                    }
                    else if (student.enabled == true && student.percent < 100) {
                        $rootScope.unlock = false;

                        $rootScope.studentToUnlockId = student.Id;
                        $rootScope.studentToUnlock = student.studente;
                        unlock();
                    }
                });
            }
        }

        function unlock() {
            if ($rootScope.unlock == true) {
                datacontext.studenteSession_unlock($rootScope.studentToUnlockId).then(function (data) {
                    $rootScope.studentToUnlockId = null;
                    $rootScope.studentToUnlock = null;
                    datacontext.studenteSession_getAllByFilter(0, 0, $scope.item.Id, '', 'nominativo').then(function (data) {
                        return $scope.allievi = data;
                    });
                });
            }
            else {
                datacontext.studenteSession_disableStudent($rootScope.studentToUnlockId).then(function (data) {
                    $rootScope.studentToUnlockId = null;
                    $rootScope.studentToUnlock = null;
                    $rootScope.unlock = null;
                    datacontext.studenteSession_getAllByFilter(0, 0, $scope.item.Id, '', 'nominativo').then(function (data) {
                        return $scope.allievi = data;
                    });
                });
            }
        }

        function disattiva() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_Session/modal/disattivaSessione.html?version=43',
                controller: 'disattivaSessione',
                resolve: {
                    sessionId: function () {
                        return $scope.item.Id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == true) {
                    monitorStop();
                    timerStop();
                    $uibModalInstance.close(true);
                }
            });
        }

        function completa() {
            var title = $translate.instant('CompletaSessioneTitolo');
            var msg = $translate.instant('CompletaSessione');
            bDialog.confirmationDialog(title, msg).then(function () {
                $scope.completaDisabled = true;
                datacontext.session_complete($scope.item.Id).then(function (data) {
                    if (data == null) {
                        $scope.annullaDisabled = false;
                        return;
                    }
                    monitorStop();
                    timerStop();
                    $scope.annullaDisabled = false;
                    $uibModalInstance.close(true);
                });
            });
        }

        function completeAuto() {
            $scope.completaDisabled = true;
            datacontext.session_complete($scope.item.Id).then(function (data) {
                if (data == null) {
                    $scope.annullaDisabled = false;
                    return;
                }
                monitorStop();
                timerStop();
                $scope.annullaDisabled = false;
                $uibModalInstance.close(true);
            });
        }

        //Timer
        function timerStart() {
            $scope.time -= 1;
            $scope.timeStr = showTime($scope.time);

            if ($scope.time <= 0) {
                completeAuto();
            }
        }

        function timerStop() {
            if (angular.isDefined($scope.timerThread)) {
                $interval.cancel($scope.timerThread);
                $scope.timerThread = undefined;
            }
        }

        //Monitoriaggio
        function monitorStart() {            
            datacontext.session_monitor($scope.item.Id).then(function (data) {
                if (data == null)
                    return;
                $scope.allievi = [];
                var actCount = 0;
                var completed = 0;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].enabled == true)
                        actCount++;

                    data[i].percentStyle = { "width": data[i].percent + "%" };
                    if (data[i].percent == 100)
                        completed++;

                    $scope.allievi.push(data[i]);
                }

                $scope.item.activeStudentsCount = actCount;

                //Se hanno completato tutti l'ultimo che risponde pone la sessione a completed e 
                //visualizzo la schermata di dettaglio sessione completata
                if (completed == data.length) {
                    monitorStop();
                    timerStop();
                    $uibModalInstance.close(true);
                }
            });
        }

        function monitorStop() {
            if (angular.isDefined($scope.monitorThread)) {
                $interval.cancel($scope.monitorThread);
                $scope.monitorThread = undefined;
            }
        }

        function showTime(sec_num) {
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            var time = hours + ':' + minutes + ':' + seconds;
            return time;
        }
    }
})();